import type { ParentProps } from "solid-js";
import styles from "./DesktopOnly.module.css";

interface Props extends ParentProps {}

export const DesktopOnly = (props: Props) => <div class={styles["desktop-only"]}>{props.children}</div>;
